/**
 * Array utility functions for common operations like sum and average
 */

/**
 * Calculate the sum of all numbers in an array
 *
 * @example
 * sum([1, 2, 3, 4]) // 10
 * sum([]) // 0
 * sum([-5, 5]) // 0
 */
export function sum(arr: number[]): number {
  return arr.reduce((total, value) => total + value, 0);
}

/**
 * Calculate the sum of values extracted from objects in an array
 *
 * @example
 * sumBy([{amount: 10}, {amount: 20}], item => item.amount) // 30
 * sumBy([], item => item.value) // 0
 */
export function sumBy<T>(arr: T[], fn: (item: T) => number): number {
  return arr.reduce((total, item) => total + fn(item), 0);
}

/**
 * Calculate the average (mean) of all numbers in an array
 * Returns 0 for empty arrays
 *
 * @example
 * average([1, 2, 3, 4]) // 2.5
 * average([10]) // 10
 * average([]) // 0
 */
export function average(arr: number[]): number {
  if (arr.length === 0) return 0;
  return sum(arr) / arr.length;
}
